import { useEffect, useState } from 'react';
import { scrollToSection } from '../hooks/useSmoothScroll';

const links = [
  { label: 'Home',      href: '#home'      },
  { label: 'Solutions', href: '#solutions' },
  { label: 'About',     href: '#about'     },
  { label: 'Enquiry',   href: '#enquiry'   },
  { label: 'Contact',   href: '#contact'   },
];

export default function Nav() {
  const [active, setActive] = useState('home');

  useEffect(() => {
    const sections = document.querySelectorAll('.section[id]');
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) setActive(e.target.id); }),
      { threshold: 0.5 }
    );
    sections.forEach(s => io.observe(s));
    return () => io.disconnect();
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <nav className="nav">
      {links.map(l => (
        <a
          key={l.href}
          href={l.href}
          className={active === l.href.slice(1) ? 'active' : ''}
          onClick={e => scrollTo(e, l.href)}
        >
          {l.label}
        </a>
      ))}
    </nav>
  );
}
